/**
 * Remote Flask (upload + verify). Dev: relative path + setupProxy → same host.
 * Prod build: full URL unless REACT_APP_USE_PROXY=1.
 */
export const API_ORIGIN = (
  process.env.REACT_APP_API_ORIGIN || "http://20.244.98.106:5500"
).replace(/\/$/, "");

const use_dev_proxy =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_USE_PROXY !== "0";

function api_url(path) {
  if (use_dev_proxy) return path;
  return `${API_ORIGIN}${path}`;
}

export const API_UPLOAD = api_url("/api/portfolio_analyzer/upload");
export const API_VERIFY_MEMBER = api_url("/api/portfolio_analyzer/verify-member");

export async function post_json(path, options = {}) {
  const url = typeof path === "string" && path.startsWith("http") ? path : api_url(path);
  let response;
  try {
    response = await fetch(url, options);
  } catch {
    throw new Error(
      `Network error — API reachable? ${API_ORIGIN} (dev: npm start + proxy).`
    );
  }

  const text = await response.text();
  const trimmed = text.trim();

  if (trimmed.startsWith("<")) {
    throw new Error(
      "The API returned HTML instead of JSON. Start both npm start and Flask on port 5500; " +
        "after upload, results appear on /analyzer."
    );
  }

  let data = {};
  if (trimmed) {
    try {
      data = JSON.parse(trimmed);
    } catch {
      throw new Error(`Invalid JSON (HTTP ${response.status})`);
    }
  }

  return { response, data };
}
